import { useQuery } from '@tanstack/react-query';
import type { BagelObjectConf } from '@bageltechnologies/bagel-common';
import { axiosInstance } from '../../../api/axios-instance';
import type { PaginatedResult } from '../../../types/common';

// Admin Bagel-object-type catalog — `GET /admin/bagel-objects` (global, no accountId), the
// conforming replacement for the customer `GET /settings/bagel-objects`. Response is
// `{ items, total, hasMore }` (was `{ bagelObjects }`); `syncable=true` matches old behavior;
// `sortBy=name` because these docs may lack `createdAt`. `_auth0` param kept so lifted callers
// (`useBagelObjects(auth0)`) compile unchanged.
const getBagelObjects = async (): Promise<BagelObjectConf[]> => {
  const res = await axiosInstance.get<PaginatedResult<BagelObjectConf>>('/admin/bagel-objects', {
    params: { syncable: true, sortBy: 'name', sortDir: 'asc', pageSize: 1000 },
  });
  return res.data.items;
};

export const useBagelObjects = (_auth0?: unknown) => {
  return useQuery({
    queryKey: ['bagelObjects'],
    queryFn: () => getBagelObjects(),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
  });
};
